import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export default function SocialMediaContact() {
  return (
    <div className="social-media">
      <a
        href=" https://web.facebook.com/ravenlivestreamapp"
        target="_blank"
        rel="noreferrer"
      >
        <FontAwesomeIcon icon={['fab', 'facebook']} size="2x" />
      </a>
      <a
        href="https://twitter.com/ravenlivestream"
        target="_blank"
        rel="noreferrer"
      >
        <FontAwesomeIcon icon={['fab', 'twitter']} size="2x" />
      </a>
      <a
        href="https://www.instagram.com/ravenlivestream"
        target="_blank"
        rel="noreferrer"
      >
        <FontAwesomeIcon icon={['fab', 'instagram']} size="2x" />
      </a>
      <a
        href="https://www.reddit.com/u/RavenLivestream?utm_medium=android_app&utm_source=share"
        target="_blank"
        rel="noreferrer"
      >
        <FontAwesomeIcon icon={['fab', 'reddit']} size="2x" />
      </a>
      <a
        href="https://www.youtube.com/channel/UClJKM1I1-PKLLSRWxNe10Dw"
        target="_blank"
        rel="noreferrer"
      >
        <FontAwesomeIcon icon={['fab', 'youtube']} size="2x" />
      </a>
    </div>
  );
}
